var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-skeleton-loader',_vm._b({attrs:{"type":"table-heading"}},'v-skeleton-loader',_vm.attrs,false)),_c('StructureImageLoader',{attrs:{"attrs":_vm.attrs}}),_c('MapSectionLoader',{attrs:{"attrs":_vm.attrs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }